<template>
  <div>
    <download-excel name="Projeção do Consumo de Insumos" :fetch="GerarExcel">
      <img class="ml-3 printer-button" src="@/assets/excel.png" :title="$t('gerar-relatorio')" :alt="$t('imprimir')" />
      <span v-if="loadingReport" class="spinner-border spinner-border-sm spinnerConfig" role="status"
        aria-hidden="true"></span>
    </download-excel>
    <b-overlay :show="waiting" variant="white" opacity="0.85" blur="50px">
    <div class="gridContainer">
      <div class="sample1 grid middle"></div>
      <div class="row">
        <div class="rowItem txtRevision" lg="3" md="4" sm="12">
          <div>ÚLTIMA REVISÃO: {{ json.revision | dateBR }}</div>
        </div>
        <div class="ybase rowItem yearSelector" xl="3" lg="3" md="4" sm="6">
          <label for="jsonBaseYear">ANO BASE</label>
          <b-form-spinbutton class="spinbutton-pentagro" id="jsonBaseYear" :disabled="this.waiting" v-model="json.baseYear" :min="(new Date().getFullYear() - 15).toString()"
                :max="(new Date().getFullYear() + 15).toString()"
            step="1"></b-form-spinbutton>
        </div>
        <div class="gridBtGroup rowItem buttons" xl="1" lg="3" md="3" sm="3">
          <img src="@/assets/salvar.png" alt="salvar" :title="$t('salvar')"
            @click="saveMaterialInputPlan($event)" />
          <img src="@/assets/cancel.png" alt="cancelar" :title="$t('cancelar')"
            @click="$bvModal.show('confirmPlanRestore')" />
        </div>
      </div>
      <b-modal id="confirmPlanRestore" ok-variant="danger" :ok-title="$t('yes')" :cancel-title="$t('no')"
        @ok="reset">Confirma o descarte das alterações?</b-modal>
    </div>
  </b-overlay>
  </div>
</template>

<script>
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { urlMainAPI, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "MaterialInputPlanGrid",
  components: {
    ...cGridAll
  },
  computed: mapState(["msg"]),
  watch: {
    async "json.baseYear"(value) {
      this.waiting = true;
      await this.loadMaterialInputPlan(value);
      this.waiting = false;
    }
  },
  data: function () {
    return {
      loadingReport: false,
      waiting: false,
      temp: [],
      json: {
        baseYear: new Date().getFullYear(),
        revision: "",
        header: [],
        table: [],
      },
    };
  },
  filters: {
    dateBR(date) {
      let dateBr = Date.parse(date);
      dateBr = new Date(dateBr);
      dateBr = dateBr.toLocaleString("pt-BR");
      dateBr = dateBr.split(" ")[0];
      if (dateBr == "Invalid") {
        return "Aguardando dados ...";
      } else {
        return dateBr.replace(",", "");
      }
    },
  },
  methods: {
    onClickRecord(rec) {
      alert(JSON.stringify(rec));
    },
    async loadMaterialInputPlan(year = this.json.baseYear) {
      defaultSuccess(this.$t('carregando-dados'));
      const url = `${urlMainAPI}/getinputmaterialusageplan/${year}/false`;
      this.waiting = true
        await axios
          .get(url)
          .then((res) => {
            this.json = res.data;
            this.temp = JSON.parse(JSON.stringify(this.json));
            this.setGrid();
            defaultSuccess(this.$t('dados-carregados'));
          })
          .catch();
          this.waiting = false
    },

    saveMaterialInputPlan: async function () {
      defaultSuccess(this.$t('salvando-dados'))
      this.waiting = true;
      const url = `${urlMainAPI}/saveinputmaterialusageplan`;
      await axios
        .post(url, this.json)
        .then((res) => {
          this.waiting = false;
          defaultSuccess(res.data);

          this.temp = JSON.parse(JSON.stringify(this.json));
          this.json.revision = new Date(Date.now());
        })
        .catch();
        this.waiting = false
    },
    reset() {
      this.json = JSON.parse(JSON.stringify(this.temp));
      this.setGrid(this.json.header, this.json.table);
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },
    createGrid() {
      const grid = new cheetahGrid.ListGrid({
        parentElement: document.querySelector(".sample1"),
        allowRangePaste: true,
        header: this.json.header,
      });
      grid.records = this.json.table;
      this.setGrid = function (
        header = this.json.header,
        table = this.json.table,
      ) {
        grid.header = header;
        grid.records = table;
      };
    },
    async GerarExcel() {
      this.loadingReport = true;
      const url = `${urlMainAPI}/getinputmaterialusageplan/${this.json.baseYear}/true`;
      const response = await this.$http.get(url);
      if (response.data.length == 0) {
        defaultSuccess(this.$t("excel-zerado"));
      } else {
        defaultSuccess("Projeção de consumo dos insumos exportado com sucesso!");
      }
      this.loadingReport = false;
      return response.data.table;
    },
  },
  async created() {
    await this.loadMaterialInputPlan();
  },
  async mounted() {
    await this.createGrid();
  },
};
</script>

<style scoped>
.gridContainer{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 51vh 100px;
  /* width: 88%; */
  /* height: 100%; */
  /* margin: auto auto; */
  row-gap: 2rem;
}

.grid {
  /* height: calc(80vh - 250px); */
  /* width: 98.5%; */
  /* display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 40vh 100px; */
  /* width: 88%; */
  /* height: 100%; */
  /* margin: auto auto; */
  border: solid 1px rgba(0, 0, 0, 0.26);
  /* row-gap: 2rem; */
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin: auto;
  width: 100%;
  /* height: 100px; */
  padding: 0 1rem;
}

.rowItem {
  margin: auto 0px;
}

.ybase {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.group {
  justify-content: space-between;
  flex-wrap: wrap;
}

.gridBtGroup {
  display: flex;
  justify-content: flex-end;
  /* padding-right: 30px; */
  column-gap: 1rem;
}

.gridBtGroup>img {
  cursor: pointer;
}

img {
  max-height: 45px;
}

.printer-button {
  position: absolute;
  height: 30px;
  width: 30px;
  cursor: pointer;
  top: 1rem;
  right: 1rem;
}

.spinnerConfig {
  width: 1.5rem; 
  height: 1.5rem;
  color: #ff5f00;
  position: absolute;
  top: 1.2rem;
  right: 3.5rem;
}

@media only screen and (max-width: 768px) {
  .rowItem {
    margin: auto;
    grid-column: 2;
  }

  .row {
    grid-template-rows: 1fr 1fr;
    align-self: center;
    margin: 10px auto;
  }

  .yearSelect {
    margin: 10px auto;
  }

  .txtRevision {
    grid-row: 2;
    grid-column: 1;
  }

  .buttons {
    grid-row: 2;
    grid-column: 3;
  }
}

@media only screen and (max-width: 727px) {
  .rowItem {
    margin: auto;
    grid-column: span 2 / 3;
  }

  .row {
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    align-self: center;
    margin: 10px auto;
  }

  .yearSelect {
    margin: 10px auto;
    padding: 10px 0px;
  }

  .txtRevision {
    grid-row: 2;
    grid-column: 1;
    padding: 10px 0px;
  }

  .buttons {
    grid-row: 2;
    grid-column: 2;
    padding: 10px 0px;
  }
}
</style>

<style>
.cheetah-grid__tooltip-element__content {
  color: white;
  /* height: 6px; */
}
</style>